<template>
  <div class="productEdit-container">
    <div class="t-top-bar">
      <el-input placeholder="请输入内容" v-model="listQuery.keyword" class="input-with-select search-input">
        <el-button slot="append" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
      </el-input>
      <el-button class="l-add-buttion"  type="primary" @click="staffHandler">员工修改</el-button>
      <el-button class="l-add-buttion"  type="primary" @click="batchHandler">批次修改</el-button>
      <el-button class="l-add-buttion"  type="warning"  @click="addHandler">产品信息修改</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%" v-loading="listLoading">
<!--      <el-table-column prop="equipmentId" label="设备编号"></el-table-column>-->
      <el-table-column prop="name" label="原员工/现员工">
        <template slot-scope="scope">{{ (scope.row.oldStaffName||'--')+'/'+(scope.row.newStaffName||'--')}}</template>
      </el-table-column>
        <el-table-column prop="name" label="原批次/现批次">
            <template slot-scope="scope">{{ (scope.row.oldBatchName||'--')+'/'+(scope.row.newBatchName||'--')}}</template>
        </el-table-column>
      <el-table-column prop="name" label="原产品/现产品">
        <template slot-scope="scope">{{ (scope.row.oldProductionName||'--')+'/'+(scope.row.newProductionName||'--')}}</template>
      </el-table-column>
      <el-table-column prop="name" label="原规格/现规格">
        <template slot-scope="scope">{{ (scope.row.oldSpecName||'--')+'-'+(scope.row.newSpecName||'--')}}</template>
      </el-table-column>
      <el-table-column prop="name" label="原工艺/现工艺">
        <template slot-scope="scope">{{ (scope.row.oldTechnologyName||'--')+'/'+(scope.row.newTechnologyName||'--')}}</template>
      </el-table-column>
        <el-table-column prop="newPrice" label="修改单价(元)">
          <template slot-scope="scope">{{(scope.row.newPrice/100).toFixed(2)}}</template>
        </el-table-column>
        <el-table-column prop="name" label="开始时间">
            <template slot-scope="scope">
                {{scope.row.beginTime | formateTime}}
            </template>
        </el-table-column>
        <el-table-column prop="name" label="结束时间">
            <template slot-scope="scope">
                {{scope.row.endTime | formateTime}}
            </template>
        </el-table-column>
      <el-table-column prop="name" label="添加时间">
          <template slot-scope="scope">
              {{scope.row.updateTime | formateTime}}
          </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size" @pagination="getList" />

    <el-dialog title="交料修正" @close="addCloseHandler" :visible.sync="addDialogVisiable" width="730px">
      <el-form :inline="true" :model="addForm" class="demo-form-inline" :rules="rules" ref="addForm">
        <el-form-item label="终端名称" prop="subEquipmentId" :label-width="formLabelWidth">
            <el-select v-model="addForm.subEquipmentId" placeholder="请选终端">
                <el-option v-for="(val,key) in subEquipments" :key="key" :label="val.equipmentName"
                           :value="val.equipmentId"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="员工名称" prop="oldStaffId" label-width="98px">
          <el-select filterable clearable v-model="addForm.oldStaffNo" placeholder="请选员工">
            <el-option  v-for="item in staffList" :key="item.staff_id" :label="item.label" :value="item.staff_no">
              <span style="float: left">{{ item.staff_no }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.staff_name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原单价(元)" prop="oldPrice"  :label-width="formLabelWidth">
          <el-input v-model="addForm.oldPrice" autocomplete="off" style="width: 215px" disabled></el-input>
        </el-form-item>
          <el-form-item label="现单价(元)" prop="newPrice"  label-width="106px">
              <el-input v-model="addForm.newPrice" autocomplete="off" style="width: 215px" disabled></el-input>
          </el-form-item>
        <el-form-item label="原产品名称" prop="oldProductionId" :label-width="formLabelWidth">
          <el-select v-model="addForm.oldProductionId" placeholder="请选产品">
            <el-option v-for="(val,key) in products" :key="key" :label="val.productionName"
                       :value="val.productionId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="现产品名称" prop="newProductionId" :label-width="formLabelWidth">
          <el-select v-model="addForm.newProductionId" placeholder="请选产品">
            <el-option v-for="(val,key) in products" :key="key" :label="val.productionName"
                       :value="val.productionId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原规格名称" prop="oldSpecId" :label-width="formLabelWidth">
            <el-select  v-model="addForm.oldSpecId" placeholder="请选规格">
                <el-option v-for="(val,key) in specs[addForm.oldProductionId]" :key="key" :label="val.specName"
                           :value="val.specId"></el-option>
            </el-select>
        </el-form-item>
          <el-form-item label="现规格名称" prop="newSpecId" :label-width="formLabelWidth">
              <el-select  v-model="addForm.newSpecId" placeholder="请选规格">
                  <el-option v-for="(val,key) in specs[addForm.newProductionId]" :key="key" :label="val.specName"
                             :value="val.specId"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="原工艺名称" prop="oldTechnologyId" :label-width="formLabelWidth">
              <el-select v-model="addForm.oldTechnologyId" placeholder="请选工艺">
                  <el-option v-for="(val,key) in technologs[addForm.oldProductionId]" :key="key" :label="val.technologyName"
                             :value="val.technologyId"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="现工艺名称" prop="newTechnologyId" :label-width="formLabelWidth">
              <el-select v-model="addForm.newTechnologyId" placeholder="请选工艺">
                  <el-option v-for="(val,key) in technologs[addForm.newProductionId]" :key="key" :label="val.technologyName"
                             :value="val.technologyId"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="开始时间" prop="beginTime" :label-width="formLabelWidth">
              <el-date-picker v-model="addForm.beginTime" type="datetime" placeholder="选择日期时间">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime" :label-width="formLabelWidth">
              <el-date-picker v-model="addForm.endTime" type="datetime" placeholder="选择日期时间">
              </el-date-picker>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisiable = false">取 消</el-button>
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批次修改" @close="batchCloseHandler" :visible.sync="batchDialogVisiable" width="730px">
      <el-form :inline="true" :model="batchForm" class="demo-form-inline" :rules="batchRules" ref="batchForm">
        <el-form-item label="原批次" prop="oldBatchId" :label-width="formLabelWidth">
          <el-select clearable v-model="batchForm.oldBatchId" placeholder="请选择批次">
            <el-option v-for="(val,key) in batchItems" :key="key" :label="val.batchName"
                       :value="val.batchId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item clearable label="现批次" prop="newBatchName" :label-width="formLabelWidth">
            <el-input v-model="batchForm.newBatchName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="beginTime" :label-width="formLabelWidth">
          <el-date-picker v-model="batchForm.beginTime" type="datetime" placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime" :label-width="formLabelWidth">
          <el-date-picker v-model="batchForm.endTime" type="datetime" placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialogVisiable = false">取 消</el-button>
        <el-button type="primary" @click="addBatchConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="员工修改" @close="staffCloseHandler" :visible.sync="staffDialogVisiable" width="730px">
      <el-form :inline="true" :model="staffForm" class="demo-form-inline" :rules="staffRules" ref="staffForm">
        <el-form-item label="原员工姓名" prop="oldStaffNo" :label-width="formLabelWidth">
          <el-select filterable clearable v-model="staffForm.oldStaffNo" placeholder="请选择">
            <el-option v-for="item in staffList" :key="item.staff_id" :label="item.label" :value="item.staff_no">
              <span style="float: left">{{ item.staff_no }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.staff_name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item clearable label="现员工姓名" prop="newStaffNo" :label-width="formLabelWidth">
          <el-select filterable clearable v-model="staffForm.newStaffNo" placeholder="请选择">
            <el-option v-for="item in staffList" :key="item.staff_id" :label="item.staff_name" :value="item.staff_no">
              <span style="float: left">{{ item.staff_no }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.staff_name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间" prop="beginTime" :label-width="formLabelWidth">
          <el-date-picker v-model="staffForm.beginTime" type="datetime" placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime" :label-width="formLabelWidth">
          <el-date-picker v-model="staffForm.endTime" type="datetime" placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="staffDialogVisiable = false">取 消</el-button>
        <el-button type="primary" @click="addStaffConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    import { getProductionVoList } from '../../api/prouction'
    import { addRecordEditLog,getRecordEditLogPageList, addRecordBatchEditLog,addRecordStaffEditLog } from '../../api/recordEdit'
    import { getEquipmentListAll } from '../../api/equipment'
    import { getBatchList } from '../../api/batch'
    import localCache from "../../util/localCache";
    import { getPriceList } from '../../api/price'
    import { getStaffListMap } from '@/api/staff'
    export default {
        name: "productEdit",
        components: {
            Pagination,
        },
        data() {
            let reg = /^\d{0,5}\.?\d{0,2}$/
            let checkPrice = (rule, value, callback) => {
                if(value === ''){
                    callback(new Error('无对应价格'));
                }
                console.log(value)
                if (!reg.test(''+value)) {
                    callback(new Error('无对应价格'));
                } else {
                    if (value < 0 || value > 99999) {
                        callback(new Error('数值范围0-99999'));
                    } else {
                        callback();
                    }
                }
            }
            return {
                addDialogVisiable: false,
                batchDialogVisiable: false,
              staffDialogVisiable: false,
                confirmVisible: false,
                formLabelWidth: '100px',
                tableData: [],
                addForm: {
                  oldProductionId:'',
                  newProductionId:'',
                  oldSpecId:'',
                  newSpecId:'',
                  oldTechnologyId:'',
                  newTechnologyId:'',
                  oldPrice: 0,
                  newPrice: 0,
                  subEquipmentId:'',
                  oldBatchId:'',
                  newBatchId:'',
                  beginTime:'',
                  endTime:'',
                  oldStaffNo:'',
                },
                rules: {
                    subEquipmentId: [
                        { required: true, message: '请选择终端', trigger: 'blur' },
                    ],
                    oldProductionId: [
                        { required: true, message: '请选择产品', trigger: 'blur' },
                    ],
                    newProductionId: [
                        { required: true, message: '请选择产品', trigger: 'blur' },
                    ],
                    oldSpecId: [
                        { required: true, message: '请选择规格', trigger: 'blur' },
                    ],
                    newSpecId: [
                        { required: true, message: '请选择规格', trigger: 'blur' },
                    ],
                    oldTechnologyId: [
                        { required: true, message: '请选择工艺', trigger: 'blur' },
                    ],
                    newTechnologyId: [
                        { required: true, message: '请选择工艺', trigger: 'blur' },
                    ],
                    newPrice: [
                        { validator: checkPrice, trigger: 'blur' }
                    ],
                  oldPrice: [
                    { validator: checkPrice, trigger: 'blur' }
                  ],
                    beginTime: [
                        { required: true, message: '请选择开始时间', trigger: 'blur' },
                    ],
                    endTime: [
                        { required: true, message: '请选择结束时间', trigger: 'blur' },
                    ],
                },
                batchForm: {
                  oldBatchId:'',
                  newBatchName:'',
                  beginTime:'',
                  endTime:'',
                },
                batchRules: {
                  newBatchName: [
                    { min: 2, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur' }
                  ],
                  beginTime: [
                    { required: true, message: '请选择开始时间', trigger: 'blur' },
                  ],
                  endTime: [
                    { required: true, message: '请选择结束时间', trigger: 'blur' },
                  ],
                },
              staffForm: {
                oldStaffNo:'',
                newStaffNo:'',
                beginTime:'',
                endTime:'',
              },
              staffRules: {
                oldStaffNo: [
                  { required: true, message: '请选择员工', trigger: 'blur' },
                ],
                newStaffNo: [
                  { required: true, message: '请选择员工', trigger: 'blur' },
                ],
                beginTime: [
                  { required: true, message: '请选择开始时间', trigger: 'blur' },
                ],
                endTime: [
                  { required: true, message: '请选择结束时间', trigger: 'blur' },
                ],
              },
                listQuery: {
                    page: 1,
                    size: 10,
                    keyword: ''
                },
                total: 0,
                listLoading: true,
                selectRow: '',
                products:[],
                specs:{},
                technologs:{},
                subEquipments: [],
                batchItems:[],
                priceMap: {},
              staffList: []
            }
        },
      watch: {
        'addForm.oldProductionId'(newValue, oldValue) {
          this.addForm.oldSpecId = ''
          this.addForm.oldTechnologyId = ''
          this.changeOldPrice()
        },
        'addForm.oldSpecId'(newValue, oldValue) {
          this.changeOldPrice()
        },
        'addForm.oldTechnologyId'(newValue, oldValue) {
          this.changeOldPrice()
        },
        'addForm.newProductionId'(newValue, oldValue) {
          this.addForm.newSpecId = ''
          this.addForm.newTechnologyId = ''
          this.changeNewPrice()
        },
        'addForm.newSpecId'(newValue, oldValue) {
          this.changeNewPrice()
        },
        'addForm.newTechnologyId'(newValue, oldValue) {
          this.changeNewPrice()
        },
      },
        mounted(){
            this.getList()
            this.getProductionVoList_()
            this.getSubEquipmentListAll_()
            this.getBatchItemList_()
          this.getStaffListMap_()
          getPriceList({
            priceType: 1,
            customerId: localCache.getCurrentCustomerId()
          }).then(res => {
            console.log(res)
            let data = res.data
            data.forEach((t) => {
              this.priceMap[t.productionId+t.technologyId+t.specId] = (t.price / 100).toFixed(2)
            })
          })
        },
        methods: {
          changeOldPrice() {
            if(this.addForm.oldProductionId && this.addForm.oldTechnologyId && this.addForm.oldSpecId){
              this.addForm.oldPrice =  this.priceMap[this.addForm.oldProductionId+this.addForm.oldTechnologyId+this.addForm.oldSpecId]
            }else{
              this.addForm.oldPrice = ''
            }
          },
          changeNewPrice() {
            if(this.addForm.newProductionId && this.addForm.newSpecId && this.addForm.newSpecId){
              this.addForm.newPrice =  this.priceMap[this.addForm.newProductionId+this.addForm.newTechnologyId+this.addForm.newSpecId]
            }else{
              this.addForm.newPrice = ''
            }
          },
            addCloseHandler(){
                this.$refs['addForm'].resetFields()
                this.addForm =  {
                  oldProductionId:'',
                  newProductionId:'',
                  oldSpecId:'',
                  newSpecId:'',
                  oldTechnologyId:'',
                  newTechnologyId:'',
                  oldPrice: 0,
                  newPrice: 0,
                  subEquipmentId:'',
                  oldBatchId:'',
                  newBatchId:'',
                  beginTime:'',
                  endTime:'',
                  oldStaffNo:'',
                }
            },
            batchCloseHandler(){
              this.$refs['batchForm'].resetFields()
              this.batchForm = {
                oldBatchId:'',
                newBatchName:'',
                beginTime:'',
                endTime:'',
              }
            },
          staffCloseHandler(){
            this.$refs['staffForm'].resetFields()
            this.staffForm = {
              oldStaffNo:'',
              newStaffNo:'',
              beginTime:'',
              endTime:'',
            }
          },
            addHandler() {
                this.opFlag='add'
                this.addDialogVisiable = true
            },
          batchHandler(){
            this.batchDialogVisiable = true
          },
          getStaffListMap_(){
            getStaffListMap({
              customerId: localCache.getCurrentCustomerId()
            }).then((res)=>{
              if(res.errorcode == 0){
                res.data.forEach((t)=>{
                  t.label = t.staff_name+t.staff_no
                })
                this.staffList = res.data
              }else{
                this.$message.error(res.message)
              }
            })
          },
          staffHandler(){
            this.staffDialogVisiable = true
          },
            getProductionName(productionId){
                console.log(productionId)
                console.log(this.products)
                for (let i = 0, len = this.products.length; i < len; i++) {
                    console.log(this.products[i].productionId == productionId)
                    if(this.products[i].productionId == productionId){
                        return this.products[i].productionName
                    }
                }
            },
            getSpecsName(specId,productionId){
                let specs = this.specs[productionId]
                for (let i = 0, len = specs.length; i < len; i++) {
                    if(specs[i].specId == specId){
                        return specs[i].specName
                    }
                }
            },
            getTechnologName(technologId,productionId){
                let technologs = this.technologs[productionId]
                for (let i = 0, len = technologs.length; i < len; i++) {
                    if(technologs[i].technologyId == technologId){
                        return technologs[i].technologyName
                    }
                }
            },
            getBatchName(id){
                for (let i = 0, len = this.batchItems.length; i < len; i++) {
                    if(this.batchItems[i].id == id){
                        return this.batchItems[i].itemId
                    }
                }
            },
            addConfirm() {
                this.$refs['addForm'].validate((valid) => {
                    if (!valid) {
                        return
                    }
                    let param = Object.assign({},this.addForm)
                    param.customerId = localCache.getCurrentCustomerId()
                    param.beginTime = this.addForm.beginTime.getTime()/1000
                    param.endTime = this.addForm.endTime.getTime()/1000
                    param.price *= 100
                    param.oldPrice = parseInt(param.oldPrice*100)
                    param.newPrice =  parseInt(param.newPrice*100)
                    param.newProductionName = this.getProductionName(param.newProductionId)
                    param.oldProductionName = this.getProductionName(param.oldProductionId)
                    param.newSpecName = this.getSpecsName(param.newSpecId,param.newProductionId)
                    param.oldSpecName = this.getSpecsName(param.oldSpecId,param.oldProductionId)
                    param.newTechnologyName = this.getTechnologName(param.newTechnologyId,param.newProductionId)
                    param.oldTechnologyName = this.getTechnologName(param.oldTechnologyId,param.oldProductionId)
                    if(param.beginTime>=param.endTime){
                        this.$message.error('开始时间不能晚于结束时间')
                        return;
                    }
                    addRecordEditLog(param).then((res) => {
                        if (res.errorcode == 0) {
                            this.$message.success('修改成功')
                            this.addDialogVisiable = false
                            this.getList()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                })
            },
            getList() {
                this.listLoading = true
                this.listQuery.customerId = localCache.getCurrentCustomerId()
                getRecordEditLogPageList(this.listQuery).then(res => {
                    this.listLoading = false
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.tableData = res.data.content
                        this.total = res.data.total
                    }
                }).catch(() => {
                    this.listLoading = false
                })
            },
            getProductionVoList_(){
                getProductionVoList({
                    customerId: localCache.getCurrentCustomerId()
                }).then(res => {
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.products = res.data
                        let data = this.products
                        for (let i = 0, len = this.products.length; i < len; i++) {
                            let pid = data[i].productionId
                            this.specs[pid] = data[i].specs
                            this.technologs[pid] = data[i].technologies
                        }
                    }
                }).catch(() => {
                })
            },
            getSubEquipmentListAll_(){
              console.log(getEquipmentListAll)
              getEquipmentListAll({
                    customerId: localCache.getCurrentCustomerId()
                }).then(res => {
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.subEquipments=  res.data
                    }
                }).catch(() => {
                })
            },
            getBatchItemList_(){
              getBatchList({
                    customerId: localCache.getCurrentCustomerId()
                }).then(res => {
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.batchItems=  res.data
                    }
                }).catch(() => {
                })
            },
          addBatchConfirm() {
            this.$refs['batchForm'].validate((valid) => {
              if (!valid) {
                return
              }
              let param = Object.assign({},this.batchForm)
              param.customerId = localCache.getCurrentCustomerId()
              param.beginTime = this.batchForm.beginTime.getTime()/1000
              param.endTime = this.batchForm.endTime.getTime()/1000

              if(param.beginTime>=param.endTime){
                this.$message.error('开始时间不能晚于结束时间')
                return;
              }
              addRecordBatchEditLog(param).then((res) => {
                if (res.errorcode == 0) {
                  this.$message.success('修改成功')
                  this.batchDialogVisiable = false
                  this.getList()
                } else {
                  this.$message.error(res.message)
                }
              })
            })
          },
          addStaffConfirm() {
            this.$refs['staffForm'].validate((valid) => {
              if (!valid) {
                return
              }
              let param = Object.assign({},this.staffForm)
              param.customerId = localCache.getCurrentCustomerId()
              param.beginTime = this.staffForm.beginTime.getTime()/1000
              param.endTime = this.staffForm.endTime.getTime()/1000

              if(param.beginTime>=param.endTime){
                this.$message.error('开始时间不能晚于结束时间')
                return;
              }
              addRecordStaffEditLog(param).then((res) => {
                if (res.errorcode == 0) {
                  this.$message.success('修改成功')
                  this.staffDialogVisiable = false
                  this.getList()
                } else {
                  this.$message.error(res.message)
                }
              })
            })
          },
        }
    }
</script>

<style lang="scss">

  .productEdit-container{
      .t-top-bar{
          margin-bottom: 15px;
      }
      .search-input {
          width: 350px;
      }
      .l-add-buttion{
          float: right;
        font-size: 16px;
        margin-left: 15px;
          cursor: pointer;
      }

  }

</style>
